import React from 'react'
import { Container } from '@material-ui/core'
import { useStyles } from './Header.styles'
import clsx from 'clsx'
import { LargeScreenNavigationBar } from './LargeScreenNavigation'
import { SmallScreenNavigation } from './SmallScreenNavigation'

interface IHeader {
  isLargeScreen: boolean
  menuProps: any
}

const Header = ({ isLargeScreen, menuProps }: IHeader) => {
  const classes = useStyles()

  return (
    <div className={classes.nav}>
      {isLargeScreen ? (
        <Container maxWidth="lg" component="nav">
          <LargeScreenNavigationBar {...menuProps} />
        </Container>
      ) : (
        <SmallScreenNavigation {...menuProps} />
      )}
      <div
        className={clsx(classes.separator, {
          [classes.mobileSeparator]: !isLargeScreen
        })}
      ></div>
    </div>
  )
}

export default Header
